export default __webpack_public_path__ + "static/media/careers-bg.95346c24.jpeg";